const config = {
  baseUrl: "https://dltsapi.azurewebsites.net",
  //baseUrl: "https://localhost:7113",
  pdfUrl: "https://red-mud-08a8ab810.2.azurestaticapps.net",
  blobUrl: "https://dltsprodstorage.blob.core.windows.net/forms/",
};

export default config;
